import React from 'react';
import { SvgIcon } from '@make-software/tg-mini-app-ui';

import Checkmark from '@/shared/assets/icons/ic-checkmark-outline.svg';

import { IconCircle, TaskRow, TaskText } from '../styled';

export interface Task {
  description: React.ReactNode;
  completed: boolean;
}

export const TaskItem: React.FC<{ task: Task }> = ({ task }) => {
  return (
    <TaskRow completed={task.completed} align="center" gap={8}>
      <IconCircle active={task.completed}>
        {task.completed && <SvgIcon src={Checkmark} size={26} />}
      </IconCircle>
      <TaskText completed={task.completed}>{task.description}</TaskText>
    </TaskRow>
  );
};
